// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"743e8a1e","703":"bfc49b7b","787":"ce3209f3"}[chunkId] + ".chunk.js";
};